const pillarsIdToModuleAppState = {
  TIMELINE: 'TIMELINE',
  HEALTH_PLAN: 'HEALTH_PLAN',
  APPOINTMENT: 'APPOINTMENT'
}

const timelineState = state => {
  if (!state.modules) return null
  return state.modules[pillarsIdToModuleAppState.TIMELINE]
}

const healthPlanState = state => {
  if (!state.modules) return null
  return state.modules[pillarsIdToModuleAppState.HEALTH_PLAN]
}

const clinicalRecordState = state => {
  if (!state.modules) return null
  return state.modules[pillarsIdToModuleAppState.APPOINTMENT]
}

export default {
  timelineState,
  healthPlanState,
  clinicalRecordState
}
